export const dict = {
  nav_shop: { id: "Belanja", en: "Shop" },
  nav_categories: { id: "Kategori", en: "Categories" },
  nav_sell: { id: "BUKA TOKO", en: "OPEN STORE" },
  nav_login: { id: "Masuk", en: "Login" },
  nav_register: { id: "Daftar", en: "Register" },
  nav_orders: { id: "Pesanan Saya", en: "My Orders" },
  nav_dashboard: { id: "Dashboard Toko", en: "Store Dashboard" },
  nav_admin: { id: "Admin", en: "Admin" },
  nav_logout: { id: "Keluar", en: "Logout" },
  cta_shop: { id: "MULAI BELANJA", en: "START SHOPPING" },
  cta_sell: { id: "BUKA TOKO SEKARANG", en: "OPEN YOUR STORE" },
  search_ph: { id: "Cari barang preloved...", en: "Search preloved items..." },
  condition: { id: "Kondisi", en: "Condition" },
  negotiable: { id: "Bisa Nego", en: "Negotiable" },
  verified: { id: "Terverifikasi", en: "Verified" },
  buy_now: { id: "Beli Sekarang", en: "Buy Now" },
  add_cart: { id: "+ Keranjang", en: "+ Cart" },
  sold: { id: "Terjual", en: "Sold" },
  all: { id: "Semua", en: "All" },
};

export const t = (key, lang) => (dict[key] ? dict[key][lang] : key);
